import { useState } from 'react';
import ForgotPassword from '../../components/Auth/ForgotPassword';
import OTPVerification from '../../components/Auth/OTPVerification';
import ResetPassword from '../../components/Auth/ResetPassword';

const ForgotPasswordFlow = () => {
    const [step, setStep] = useState<number>(1);

    return (
        <>
            {step === 1 && <ForgotPassword onNext={() => setStep(2)} />}
            {step === 2 && <OTPVerification onNext={() => setStep(3)} />}
            {step === 3 && <ResetPassword />}
        </>
    );
};

export default ForgotPasswordFlow;
